import { render, staticRenderFns } from "./FeedBackList.vue?vue&type=template&id=57570426&scoped=true"
import script from "./FeedBackList.vue?vue&type=script&lang=js"
export * from "./FeedBackList.vue?vue&type=script&lang=js"
import style0 from "./FeedBackList.vue?vue&type=style&index=0&id=57570426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57570426",
  null
  
)

export default component.exports